import React, { useState } from 'react'

import { CalculateProfitModal, CalculateProfitPricing } from '@fourthwall/components'

import { getEstimatedPaymentProcessingFees, getUnitProfit } from '../CalculateProfit/utils'

export type PerSizePricingEntryData = {
  price: string
  cost: number
  label: string
}

export type PerSizePricingData = {
  price: string
  cost: number
  label: string
  feesValue: number
  unitProfit: number
}

export const getSizesPerCost = (
  perSizePrice: PerSizePricingEntryData[],
  includeFees: boolean,
): PerSizePricingData[] => {
  return perSizePrice.map(({ price, cost, label }) => {
    const priceValue = Number(price)

    const unitProfit = getUnitProfit(priceValue, cost, includeFees)
    const feesValue = getEstimatedPaymentProcessingFees(priceValue)

    return {
      feesValue,
      unitProfit,
      price: priceValue.toString(),
      cost,
      label,
    }
  })
}

export type CalculateManualFilledProfitProps = {
  perSizePrice: PerSizePricingEntryData[]
}

export const CalculateProfitForPerSizeProduct = ({
  perSizePrice,
}: CalculateManualFilledProfitProps) => {
  const [includeFeesValue, setIncludeFeesValue] = useState(false)
  const [data, setData] = useState<PerSizePricingEntryData[]>(perSizePrice)

  const sizesPerCost = getSizesPerCost(data, includeFeesValue)

  // eslint-disable-next-line default-param-last
  const handleSellingPriceChange = (value = '0', index: number) => {
    setData((prevState) => {
      const newState = [...prevState]

      newState[index].price = value

      return newState
    })
  }

  const handleToggleIncludeFeesValue = () => setIncludeFeesValue((prevState) => !prevState)

  return (
    <CalculateProfitModal.Root
      title="Profit on-demand for products"
      content={
        <CalculateProfitPricing.PerSizePricing
          data={sizesPerCost}
          includeFeesValue={includeFeesValue}
          onPriceChange={handleSellingPriceChange}
        />
      }
      includeFeesValue={includeFeesValue}
      suggestions={[
        'On-demand products have a single manufacturing price, regardless of how many are ordered.',
        'Selling price is automatically adjusted so you make the same amount on different sizes.',
      ]}
      onToggleIncludeFeesValue={handleToggleIncludeFeesValue}
    />
  )
}
